/**
 * @generated SignedSource<<8af192af5a60a74bc9b5a5a00b908b12>>
 * @relayHash d0c92b0a02babeaefbf81c25e350b9a8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7fcba28610d4d0a69b897174ef84bbb22c00450f09f807a16e5ffb16dccf0bf3

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { WorkforceOptimizationExperimentPageQuery } from './WorkforceOptimizationExperimentPageQuery.graphql';

const node: PreloadableConcreteRequest<WorkforceOptimizationExperimentPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "7fcba28610d4d0a69b897174ef84bbb22c00450f09f807a16e5ffb16dccf0bf3",
    "metadata": {},
    "name": "WorkforceOptimizationExperimentPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
